import { render, staticRenderFns } from "./UserManagementModal.vue?vue&type=template&id=3dc8a623"
import script from "./UserManagementModal.vue?vue&type=script&lang=js"
export * from "./UserManagementModal.vue?vue&type=script&lang=js"
import style0 from "./UserManagementModal.vue?vue&type=style&index=0&id=3dc8a623&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports